<template>
  <div>
    <header class="h_header">
      <div class="h_top v-container d-flex align-items-center">
        <div class="h_logo">
          <b-img
            src="@/assets/images/anan-img/logo/logo_top.png"
            alt="logo"
            title="anan-cargo-logo"
          />
        </div>
      </div>
    </header>

    <main>
      <div class="bg_content">
        <div class="bg_content2 p-md-5 p-1">
          <div class="row">
            <div class="col-md-6">
              <div class="text-center text-white h-100 mt-10">
                <div>
                  <b-img
                    src="@/assets/images/anan-img/svg/logo_anan.svg"
                    alt="logo"
                    title="anan-cargo-logo"
                    class="w-50"
                  />
                </div>

                <div class="mt-10 mb-10">
                  <h1
                    class="text-white"
                    style="letter-spacing: 5px"
                  >
                    บริการรับนำเข้าสินค้า
                  </h1>
                  <h3 class="text-white">
                    <span class="text-warning">จากจีนมาไทย</span> ทุกรูปแบบ
                  </h3>
                </div>
              </div>
            </div>

            <div class="col-md-6">
              <div class="bg-login">
                <div class="mb-2">
                  <h2>เปลี่ยนรหัสผ่าน</h2>
                </div>
                <validation-observer
                  ref="changePasswordValidation"
                  #default="{ handleSubmit }"
                >
                  <b-form @submit.prevent="handleSubmit(confirmData)">
                    <b-form-group
                      label="รหัสผ่านปัจจุบัน"
                      label-for="current-password"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="รหัสผ่านปัจจุบัน"
                        rules="required"
                      >
                        <b-input-group class="input-group-merge">
                          <b-form-input
                            id="current-password"
                            v-model="currentPassword"
                            :state="errors.length > 0 ? false : null"
                            :type="currentPasswordFieldType"
                            name="current-password"
                            placeholder="••••••••••••"
                          />
                          <b-input-group-append
                            is-text
                            @click="toggleCurrentPasswordVisibility"
                          >
                            <span class="password-toggle-icon">{{ currentPasswordToggleIcon }}</span>
                          </b-input-group-append>
                        </b-input-group>
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>

                    <b-form-group
                      label="รหัสผ่านใหม่"
                      label-for="rg-password"
                    >
                      <validation-provider
                        #default="{ errors }"
                        vid="Password"
                        name="รหัสผ่านใหม่"
                        rules="required"
                      >
                        <b-input-group class="input-group-merge">
                          <b-form-input
                            id="rg-password"
                            v-model="password"
                            :state="errors.length > 0 ? false : null"
                            :type="newPasswordFieldType"
                            name="login-password"
                            placeholder="············"
                          />
                          <b-input-group-append
                            is-text
                            @click="toggleNewPasswordVisibility"
                          >
                            <span class="password-toggle-icon">{{ newPasswordToggleIcon }}</span>
                          </b-input-group-append>
                        </b-input-group>
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>

                    <b-form-group
                      label="ยืนยันรหัสผ่านใหม่"
                      label-for="rg-password-confirm"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="ยืนยันรหัสผ่านใหม่"
                        rules="required|confirmed:Password"
                      >
                        <b-input-group class="input-group-merge">
                          <b-form-input
                            id="rg-password-confirm"
                            v-model="passwordCon"
                            :state="errors.length > 0 ? false : null"
                            :type="confirmPasswordFieldType"
                            placeholder="ยืนยันรหัสผ่าน"
                          />
                          <b-input-group-append
                            is-text
                            @click="toggleConfirmPasswordVisibility"
                          >
                            <span class="password-toggle-icon">{{ confirmPasswordToggleIcon }}</span>
                          </b-input-group-append>
                        </b-input-group>
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>

                    <b-button
                      type="submit"
                      variant="primary"
                      block
                      size="lg"
                      :disabled="isDisabled"
                    >
                      <span
                        v-if="isDisabled"
                        class="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      />
                      <span v-else>ยืนยัน</span>
                    </b-button>
                  </b-form>
                </validation-observer>

                <b-row>
                  <b-col
                    cols="12"
                    class="text-center mt-2"
                  >
                    <span>
                      <router-link
                        class="text-primary ms-2 mb-1 font-weight-bolder"
                        :to="{ name: 'dashboard' }"
                      >
                        กลับสู่หน้าหลัก
                      </router-link>
                    </span>
                  </b-col>
                </b-row>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>

    <this-footer />
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BFormGroup,
  BRow,
  BCol,
  BForm,
  BFormInput,
  BButton,
  BImg,
  BInputGroup, // เพิ่ม
  BInputGroupAppend, // เพิ่ม
} from 'bootstrap-vue'
import { required } from '@validations'
// ลบ mixin togglePasswordVisibility ออก เนื่องจากเราจะทำเองเพื่อให้ควบคุมช่องรหัสผ่าน 3 ช่องได้ง่ายขึ้น
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import ThisFooter from './component/ThisFooter.vue'

export default {
  components: {
    ThisFooter,
    BFormGroup,
    ValidationProvider,
    ValidationObserver,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BImg,
    BForm,
    BInputGroup, // เพิ่ม
    BInputGroupAppend, // เพิ่ม
  },
  // ลบ mixin [togglePasswordVisibility] ออก
  data() {
    return {
      required,
      currentPassword: null,
      password: null, // New password
      passwordCon: null, // Confirm new password
      isDisabled: false,
      username: '',
      // State สำหรับการซ่อน/แสดงรหัสผ่านแต่ละช่อง
      currentPasswordFieldType: 'password',
      newPasswordFieldType: 'password',
      confirmPasswordFieldType: 'password',
    }
  },
  computed: {
    // Computed property สำหรับ Icon Toggle ของช่องรหัสผ่านปัจจุบัน
    currentPasswordToggleIcon() {
      return this.currentPasswordFieldType === 'password' ? '👁️' : '🔒' // ใช้ Emoji/Text แทน Icon Component ถ้าไม่มี
      // ถ้าใช้ Feather Icons: return this.currentPasswordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    // Computed property สำหรับ Icon Toggle ของช่องรหัสผ่านใหม่
    newPasswordToggleIcon() {
      return this.newPasswordFieldType === 'password' ? '👁️' : '🔒'
    },
    // Computed property สำหรับ Icon Toggle ของช่องยืนยันรหัสผ่านใหม่
    confirmPasswordToggleIcon() {
      return this.confirmPasswordFieldType === 'password' ? '👁️' : '🔒'
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    // Methods สำหรับการซ่อน/แสดงรหัสผ่าน
    toggleCurrentPasswordVisibility() {
      this.currentPasswordFieldType = this.currentPasswordFieldType === 'password' ? 'text' : 'password'
    },
    toggleNewPasswordVisibility() {
      this.newPasswordFieldType = this.newPasswordFieldType === 'password' ? 'text' : 'password'
    },
    toggleConfirmPasswordVisibility() {
      this.confirmPasswordFieldType = this.confirmPasswordFieldType === 'password' ? 'text' : 'password'
    },
    async getData() {
      try {
        const { data: res } = await this.$http.get('/Profilecustomer/show')
        this.username = res.username
      } catch (e) {
        console.error(e) // เปลี่ยน console.log เป็น console.error
      }
    },
    confirmData() {
      // ไม่ต้องเรียก validate() ซ้ำ เพราะเราใช้ handleSubmit(confirmData) แล้ว
      // และ Vee-Validate จะเรียก validate() ให้ก่อน
      this.isDisabled = true // เริ่ม Disabled ทันทีเมื่อข้อมูลผ่าน Validation เบื้องต้น

      if (this.password !== this.passwordCon) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'รหัสผ่านไม่ตรงกัน',
            icon: 'EditIcon',
            variant: 'warning',
          },
        })
        this.isDisabled = false
        return // ออกจากฟังก์ชันทันที
      }

      const obj = {
        password: this.password,
        currentPassword: this.currentPassword,
      }

      this.$http.post('/users/UpdatePass', obj)
        .then(response => {
          if (response.data.status) {
            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: 'เปลี่ยนรหัสผ่านสำเร็จ',
                icon: 'CheckIcon',
                variant: 'success',
                text: 'คุณได้ทำการเปลี่ยนรหัสผ่านเรียบร้อยแล้ว',
              },
            })
            // Clear inputs on success
            this.currentPassword = null
            this.password = null
            this.passwordCon = null
            // Reset validation state
            this.$nextTick(() => {
              this.$refs.changePasswordValidation.reset()
            })

            setTimeout(() => {
              this.$router.push('/')
            }, 1000)
          } else {
            this.SwalError(response.data.message || 'เกิดข้อผิดพลาดในการเปลี่ยนรหัสผ่าน')
          }
        })
        .catch(err => {
          // ใช้ err.response.data.message เพื่อเข้าถึงข้อความ Error จาก API
          this.SwalError(err.response?.data?.message || 'เกิดข้อผิดพลาดในการติดต่อระบบ')
          console.error(err)
        })
        .finally(() => {
          this.isDisabled = false // ปิด Disabled เสมอไม่ว่าจะสำเร็จหรือล้มเหลว
        })
    },
    SwalError(message) {
      this.$swal({
        title: 'Error!',
        text: message,
        icon: 'error',
        confirmButtonText: 'ตกลง', // เปลี่ยน Cool เป็นภาษาไทย
      })
    },
  },
}
</script>

<style scoped>
/* เพิ่ม CSS สำหรับ Icon Toggle เพื่อให้สามารถคลิกได้ และแสดง cursor เป็น pointer */
.password-toggle-icon {
  cursor: pointer;
  /* ปรับขนาดหรือสีตามความเหมาะสมของดีไซน์ */
}
</style>
